import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";

const TermsOfUse = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: "#F5F5F5",
      }}
    >
      <Box
        sx={{
          maxWidth: "1440px",
          px: "100px",
          py: "56px",
          "@media (max-width: 1360px)": {
            px: "16px",
            py: "32px",
          },
        }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
            p: "48px",
            "@media (max-width: 1024px)": {
              p: "36px",
            },
            "@media (max-width: 856px)": {
              p: "16px",
            },
          }}
        >
          {/* Main Title */}
          <Typography
            sx={{
              fontSize: "36px",
              fontWeight: "700",
              color: "#333",
              mb: 4,
              lineHeight: 1.2,
            }}
          >
            Terms of Use
          </Typography>

          {/* Subtitle */}
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#333",
              mb: 2,
              lineHeight: 1.3,
            }}
          >
            Terms and Conditions for Use of This Web Site
          </Typography>

          {/* Introduction */}
          <Typography
            sx={{
              fontSize: "16px",
              color: "#666",
              mb: 4,
              lineHeight: 1.6,
            }}
          >
            Your access to and use of this web site (the "Site") is conditioned on acceptance of the terms of conditions set forth herein. Read these terms before using the Site. By accessing, using, viewing, browsing the Site, you agree to these terms. If you do not agree to these terms, do not access the Site in any way.
          </Typography>

          {/* Materials Section */}
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#333",
              mb: 2,
              lineHeight: 1.3,
            }}
          >
            Materials
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              color: "#666",
              mb: 4,
              lineHeight: 1.6,
            }}
          >
            The materials (including but not limited to the text, information, data, audio, video and computer programs) (the "Materials") on this Site are provided by R3PLAY LLC as a service to public and may be used for informational purposes only.
          </Typography>

          {/* Copyrights Section */}
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#333",
              mb: 2,
              lineHeight: 1.3,
            }}
          >
            Copyrights
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              color: "#666",
              mb: 4,
              lineHeight: 1.6,
            }}
          >
            Some of the Materials at the Site are copyrighted and any unauthorized use of any of the Materials at the Site may violate copyright, trademark, and other laws. You may not copy, reproduce, modify, republish, upload, post, transmit or distribute the Materials in any way unless you obtain permission in writing from R3PLAY LLC in advance.
          </Typography>

          {/* Updates Section */}
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#333",
              mb: 2,
              lineHeight: 1.3,
            }}
          >
            Updates to the Terms and Conditions Document
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              color: "#666",
              mb: 2,
              lineHeight: 1.6,
            }}
          >
            R3PLAY LLC may revise these terms and conditions for use at any time by updating the "Terms and Conditions for Use of This Web Site" page. You should visit this page from time to time to review the then current terms and conditions for use, because they are binding on you. Certain provisions of these terms and conditions may be superseded by expressly designated legal notices or terms located on particular pages at the Site.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TermsOfUse;
